export enum CreditCardType {
    VISA = 'visa',
    MASTERCARD = 'mastercard',
    MAESTRO = 'maestro',
    DISCOVER = 'discover',
    JCB = 'jcb',
    AMEX = 'american-express',
}
